(function () {
  if (window.__productModalInitialized) return;
  window.__productModalInitialized = true;

  function ensureProductModal() {
    let modal = document.getElementById('ProductModal');
    if (!modal) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = `
        <div id="ProductModal" class="Modal" hidden role="dialog" aria-modal="true" aria-labelledby="ProductModalTitle">
          <div class="Modal__backdrop" data-modal-close></div>
          <div class="Modal__dialog" role="document">
            <button type="button" class="Modal__close" data-modal-close aria-label="閉じる">×</button>
            <div id="ProductModalBody" class="Modal__inner" tabindex="0"></div>
          </div>
        </div>`;
      document.body.appendChild(wrapper.firstElementChild);
      modal = document.getElementById('ProductModal');
    }
    return modal;
  }

  function loadLeeepOnce(callback) {
    if (window.LeeepCite && typeof window.LeeepCite.init === 'function') {
      callback();
      return;
    }

    const existing = document.querySelector('script[src*="cite.leeep.jp/v2/embed/js"]');
    if (existing) {
      if (existing.dataset._leeepLoaded) {
        callback();
      } else {
        existing.addEventListener('load', function onLoad() {
          existing.dataset._leeepLoaded = '1';
          callback();
        }, { once: true });
      }
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cite.leeep.jp/v2/embed/js';
    script.defer = true;
    script.addEventListener('load', function () {
      script.dataset._leeepLoaded = '1';
      callback();
    }, { once: true });
    document.head.appendChild(script);
  }

  const modal = ensureProductModal();
  const modalBody = document.getElementById('ProductModalBody');
  let lastTrigger = null;

  function openModalFromTemplateId(templateId) {
    const template = document.getElementById(templateId);
    if (!template || !modalBody) return;

    modalBody.innerHTML = '';
    modalBody.appendChild(template.content.cloneNode(true));
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    const leeepDiv = modalBody.querySelector('[id^="leeep-tag-"]');
    if (leeepDiv) {
      const tagId = leeepDiv.id.replace('leeep-tag-', '');
      loadLeeepOnce(function () {
        if (window.LeeepCite && typeof window.LeeepCite.init === 'function') {
          window.LeeepCite.init({ tag_id: tagId });
        }
      });
    }

    const focusable = modal.querySelector('.Modal__close') || modalBody;
    focusable.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-modal-content-id]');
    if (button) {
      event.preventDefault();
      lastTrigger = button;
      openModalFromTemplateId(button.getAttribute('data-modal-content-id'));
      return;
    }

    if (event.target.closest('[data-modal-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  modal.addEventListener('click', function (event) {
    if (event.target.classList.contains('Modal__backdrop')) closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (!modal.hidden && event.key === 'Escape') {
      event.preventDefault();
      closeModal();
    }
  });

  window.openProductTemplateModal = openModalFromTemplateId;
})();
